module.exports = __webpack_public_path__ + "media/images/lb/151-f96bd1ca3955677f1936a963707464fc.svg";